;(function(){

    const getCards = (root) => {
        const scope = root instanceof Element ? root : document;
        const cards = scope.matches && scope.matches('.m-card-projet') ? [scope] : [];

        return cards.concat(Array.from(scope.querySelectorAll('.m-card-projet')));
    };

    const initCards = (root = document) => {
        const cards = getCards(root);
        if(!cards.length) return;

        cards.forEach(card => {
            if (card.dataset.cardProjetInit === 'true') return;
            card.dataset.cardProjetInit = 'true';

            const thumbnail = card.querySelector('.m-card-projet__thumbnail');
            const titre = card.querySelector('.m-card-projet__titre');

            // Fonction pour activer l'état survolé sur la carte entière
            const addHoverState = () => card.classList.add('hovered');
            const removeHoverState = () => card.classList.remove('hovered');

            // 1. Interactions Thumbnail
            if(thumbnail) {
                thumbnail.addEventListener('mouseenter', addHoverState);
                thumbnail.addEventListener('mouseleave', removeHoverState);
            }

            // 2. Interactions Titre
            if(titre) {
                titre.addEventListener('mouseenter', () => {
                    addHoverState();
                    
                    // Envoi du Custom Event
                    const event = new CustomEvent('LABEL:HOVERED', {
                        bubbles: true, // Permet à l'event de remonter
                        detail: { card: card } // On passe la carte en paramètre si besoin
                    });
                    document.dispatchEvent(event);
                });

                titre.addEventListener('mouseleave', removeHoverState);
            }
        });
    };

    window.hdsInitCardProjet = initCards;
    initCards();

})(); 
